import styled from 'styled-components';
import { customTextColor } from '../../../constants/CommonStyles';

export const P18B = styled.p`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.1px;
  ${customTextColor}
`;
